import axios from 'axios';
import { API_URL } from '../config';

const BITRIX_API_URL = process.env.REACT_APP_BITRIX_URL || '';


class BitrixAPI {
  static formatFiles(filesArray) {
    if (!filesArray || !Array.isArray(filesArray)) return [];
    
    return filesArray.map(file => {
      if (!file) return null;
      
      
      if (typeof file === 'object' && file.id) {
        return {
          id: file.id,
          name: file.name || `Чертеж ${file.id}`,
          url: file.urlMachine || file.url || null
        };
      }
      
      
      return {
        id: file,
        name: `Чертеж ${file}`,
        url: null
      };
    }).filter(file => file !== null); 
  }


  

  static async getActiveOrderscutting() {
    try {
      const token = localStorage.getItem('token');
      const config = {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      };

      let allItems = [];
      let start = 0;
      const limit = 50; // Максимум для Bitrix24 API
      let hasMore = true;

      // Загружаем все заказы с пагинацией
      while (hasMore) {
        const response = await axios.get(`${BITRIX_API_URL}crm.item.list`, {
          params: {
            'entityTypeId': '1036',
            'filter[stageId]': 'DT1036_6:UC_58B1IG',
            'select[]': [
              'id',
              'title',
              'ufCrm3_1746789101',    // Номер заказа
              'ufCrm3_1746789910',    // Деталировка чертежа
              'ufCrm3_1746789890'     // Дизайн чертежа
            ],
            'start': start
          }
        });

        const items = response.data.result.items || [];
        allItems = allItems.concat(items);

        // Проверяем, есть ли еще записи
        // Если получили полную страницу (50 элементов), продолжаем загрузку
        hasMore = items.length === limit;
        start += limit;

        if (items.length > 0) {
          console.log(`✅ Загружено ${items.length} заказов резки (итого: ${allItems.length})`);
        }

        // Защита от бесконечного цикла
        if (start > 1000) {
          console.warn('⚠️ Достигнут лимит в 1000 заказов, прерываем загрузку');
          break;
        }
      }

      console.log(`🎯 Итого загружено заказов резки: ${allItems.length}`);

      return allItems.map(item => {
        const mainFiles = this.formatFiles(item.ufCrm3_1746789910);
        const prodFiles = this.formatFiles(item.ufCrm3_1746789890);

        return {
          id: item.id,
          orderNumber: item.ufCrm3_1746789101 || 'Без номера',
          title: item.title || 'Без названия',
          status: 'new',
          files: mainFiles,
          productionFiles: prodFiles
        };
      });
    } catch (error) {
      console.error('Ошибка при получении заказов:', error);
      throw error;
    }
  }

  
  static async getActiveOrdersdrilling() {
    try {
      const token = localStorage.getItem('token');
      const config = {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      };

      let allItems = [];
      let start = 0;
      const limit = 50; // Максимум для Bitrix24 API
      let hasMore = true;

      // Загружаем все заказы с пагинацией
      while (hasMore) {
        const response = await axios.get(`${BITRIX_API_URL}crm.item.list`, {
          params: {
            'entityTypeId': '1036',
            'filter[stageId]': 'DT1036_6:UC_HD3BPN',
            'select[]': [
              'id',
              'title',
              'ufCrm3_1746789101',    // Номер заказа
              'ufCrm3_1746789910',    // Деталировка чертежа
              'ufCrm3_1746789890'     // Дизайн чертежа
            ],
            'start': start
          }
        });

        const items = response.data.result.items || [];
        allItems = allItems.concat(items);

        // Проверяем, есть ли еще записи
        // Если получили полную страницу (50 элементов), продолжаем загрузку
        hasMore = items.length === limit;
        start += limit;

        if (items.length > 0) {
          console.log(`✅ Загружено ${items.length} заказов сверловки (итого: ${allItems.length})`);
        }

        // Защита от бесконечного цикла
        if (start > 1000) {
          console.warn('⚠️ Достигнут лимит в 1000 заказов, прерываем загрузку');
          break;
        }
      }

      console.log(`🎯 Итого загружено заказов сверловки: ${allItems.length}`);

      return allItems.map(item => {
        const mainFiles = this.formatFiles(item.ufCrm3_1746789910);
        const prodFiles = this.formatFiles(item.ufCrm3_1746789890);

        return {
          id: item.id,
          orderNumber: item.ufCrm3_1746789101 || 'Без номера',
          title: item.title || 'Без названия',
          status: 'new',
          files: mainFiles,
          productionFiles: prodFiles
        };
      });
    } catch (error) {
      console.error('Ошибка при получении заказов:', error);
      throw error;
    }
  }

static async getActiveOrderszakalka() {
    try {
      const token = localStorage.getItem('token');
      const config = {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      };

      let allItems = [];
      let start = 0;
      const limit = 50;
      let hasMore = true;

      while (hasMore) {
        const response = await axios.get(`${BITRIX_API_URL}crm.item.list`, {
          params: {
            'entityTypeId': '1036',
            'filter[stageId]': 'DT1036_6:UC_TACW0R',
            'select[]': [
              'id',
              'title',
              'ufCrm3_1746789101',    // Номер заказа
              'ufCrm3_1746789910',    // Деталировка чертежа
              'ufCrm3_1746789890',    // Дизайн чертежа
              'ufCrm3_DELIVERY_INFO'  // Информация о доставке от водителя
            ],
            'start': start
          }
        });

        const items = response.data.result.items || [];
        allItems = allItems.concat(items);

        hasMore = items.length === limit;
        start += limit;

        if (items.length > 0) {
          console.log(`✅ Загружено ${items.length} заказов закалки (итого: ${allItems.length})`);
        }

        if (start > 1000) {
          console.warn('⚠️ Достигнут лимит в 1000 заказов, прерываем загрузку');
          break;
        }
      }

      console.log(`🎯 Итого загружено заказов закалки: ${allItems.length}`);

      return allItems.map(item => {
        const mainFiles = this.formatFiles(item.ufCrm3_1746789890);
        const prodFiles = this.formatFiles(item.ufCrm3_1746789910);

        return {
          id: item.id,
          orderNumber: item.ufCrm3_1746789101 || 'Без номера',
          title: item.title || 'Без названия',
          status: 'new',
          files: mainFiles,
          productionFiles: prodFiles,
          deliveryInfo: item.ufCrm3_DELIVERY_INFO || null
        };
      });
    } catch (error) {
      console.error('Ошибка при получении заказов:', error);
      throw error;
    }
  }

  static async getNazakOrders() {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    };

    let allItems = [];
    let start = 0;
    const limit = 50;
    let hasMore = true;

    while (hasMore) {
      const response = await axios.get(`${BITRIX_API_URL}crm.item.list`, {
        params: {
          'entityTypeId': '1036',
          'filter[stageId]': 'DT1036_6:UC_PBEINX', // стадия nazak
          'select[]': [
            'id',
            'title',
            'ufCrm3_1746789101',    // Номер заказа
            'ufCrm3_1746789910',    // Деталировка чертежа
            'ufCrm3_1746789890'     // Дизайн чертежа

          ],
          'start': start
        }
      });

      const items = response.data.result.items || [];
      allItems = allItems.concat(items);

      hasMore = items.length === limit;
      start += limit;

      if (items.length > 0) {
        console.log(`✅ Загружено ${items.length} заказов nazak (итого: ${allItems.length})`);
      }

      if (start > 1000) {
        console.warn('⚠️ Достигнут лимит в 1000 заказов, прерываем загрузку');
        break;
      }
    }

    console.log(`🎯 Итого загружено заказов nazak: ${allItems.length}`);

    return allItems.map(item => {
      const mainFiles = this.formatFiles(item.ufCrm3_1746789910);
      const prodFiles = this.formatFiles(item.ufCrm3_1746789890);

      // Форматируем даты
      const createdDate = item.createdTime ? new Date(item.createdTime).toLocaleDateString() : '';
      const updatedDate = item.updatedTime ? new Date(item.updatedTime).toLocaleDateString() : '';

      return {
        id: item.id,
        orderNumber: item.ufCrm3_1746789101 || 'Без номера',
        title: item.title || 'Без названия',
        status: 'nazak',
        files: mainFiles,
        productionFiles: prodFiles,
        createdDate,
        updatedDate
      };
    });
  } catch (error) {
    console.error('Ошибка при получении заказов nazak:', error);
    throw error;
  }
}

// Функция для перевода заказа из стадии nazak в активную стадию закалки
static async updateFromNazakToZakalka(orderId) {
  try {
    const token = localStorage.getItem('token');
    
    const response = await axios.post(`${API_URL}/api/updateFromNazakToZakalka`, 
      {
        itemId: orderId
      },
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error('Ошибка при переводе из nazak в закалку:', error);
    throw error;
  }
}

static async updateFromZakalkaToNazak(orderId) {
  try {
    const token = localStorage.getItem('token');
    
    const response = await axios.post(`${API_URL}/api/updateFromZakalkaToNazak`, 
      {
        itemId: orderId
      },
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error('Ошибка при переводе из закалки в nazak:', error);
    throw error;
  }
}

static async updateStagezakalka(orderId) {
  try {
    const token = localStorage.getItem('token');
    
    const response = await axios.post(`${API_URL}/api/updateStagezakalka`, 
      {
        itemId: orderId
      },
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error('Ошибка при обновлении стадии закалки:', error);
    throw error;
  }
}

static async updateStagematovka(orderId) {
  try {
    const token = localStorage.getItem('token');
    
    const response = await axios.post(`${API_URL}/api/updateStagematovka`, 
      {
        itemId: orderId
      },
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error('Ошибка при обновлении стадии закалки:', error);
    throw error;
  }
}


  static async getActiveOrdersmatovka() {
    try {
      const token = localStorage.getItem('token');
      const config = {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      };

      let allItems = [];
      let start = 0;
      const limit = 50;
      let hasMore = true;

      while (hasMore) {
        const response = await axios.get(`${BITRIX_API_URL}crm.item.list`, {
          params: {
            'entityTypeId': '1036',
            'filter[stageId]': 'DT1036_6:UC_4FXLEO',
            'select[]': [
              'id',
              'title',
              'ufCrm3_1746789101',
              'ufCrm3_1746789910',    // Деталировка чертежа
              'ufCrm3_1746789890'     // Дизайн чертежа
            ],
            'start': start
          }
        });

        const items = response.data.result.items || [];
        allItems = allItems.concat(items);

        hasMore = items.length === limit;
        start += limit;

        if (items.length > 0) {
          console.log(`✅ Загружено ${items.length} заказов матовки (итого: ${allItems.length})`);
        }

        if (start > 1000) {
          console.warn('⚠️ Достигнут лимит в 1000 заказов, прерываем загрузку');
          break;
        }
      }

      console.log(`🎯 Итого загружено заказов матовки: ${allItems.length}`);

      return allItems.map(item => {
        const mainFiles = this.formatFiles(item.ufCrm3_1746789890);
        const prodFiles = this.formatFiles(item.ufCrm3_1746789910);

        return {
          id: item.id,
          orderNumber: item.ufCrm3_1746789101 || 'Без номера',
          title: item.title || 'Без названия',
          status: 'new',
          files: mainFiles,
          productionFiles: prodFiles
        };
      });
    } catch (error) {
      console.error('Ошибка при получении заказов:', error);
      throw error;
    }
  }


// Добавьте этот метод в класс BitrixAPI в файле bitrix.js

static async getCompletedOrders() {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    };

    let allItems = [];
    let start = 0;
    const limit = 50;
    let hasMore = true;

    while (hasMore) {
      // Используем ID стадии готовых заказов
      const response = await axios.get(`${BITRIX_API_URL}crm.item.list`, {
        params: {
          'entityTypeId': '1036',
          'filter[stageId]': 'DT1036_8:CLIENT', // ID стадии готовых заказов
          'order[id]': 'DESC', // Сортировка от новых к старым (по ID)
          'select[]': [
            'id',
            'title',
            'ufCrm3_1746789101',       // Номер заказа
            'ufCrm7_1725965080328',    // Основные чертежи
            'ufCrm_1665746232568',     // Чертежи для производства
            'ufCrm3_1752145811415',    // Файлы склада (base64)
            'ufCrm3_1753795707997',    // Файлы фурнитуры
            'createdTime',             // Время создания
            'updatedTime'              // Время обновления
          ],
          'start': start
        }
      });

      const items = response.data.result.items || [];
      allItems = allItems.concat(items);

      hasMore = items.length === limit;
      start += limit;

      if (items.length > 0) {
        console.log(`✅ Загружено ${items.length} готовых заказов (итого: ${allItems.length})`);
      }

      if (start > 1000) {
        console.warn('⚠️ Достигнут лимит в 1000 заказов, прерываем загрузку');
        break;
      }
    }

    console.log(`🎯 Итого загружено готовых заказов: ${allItems.length}`);

    return allItems.map(item => {
      const mainFiles = this.formatFiles(item.ufCrm7_1725965080328);
      const prodFiles = this.formatFiles(item.ufCrm_1665746232568);
      // Пробуем оба поля для файлов склада
      const storageFiles1 = this.formatFiles(item.ufCrm3_1752145811415);
      const storageFiles2 = this.formatFiles(item.ufCrm3_1753795707997);
      const storageFiles = storageFiles1.length > 0 ? storageFiles1 : storageFiles2;

      // Форматируем даты
      const createdDate = item.createdTime ? new Date(item.createdTime).toLocaleDateString() : '';
      const updatedDate = item.updatedTime ? new Date(item.updatedTime).toLocaleDateString() : '';

      return {
        id: item.id,
        orderNumber: item.ufCrm3_1746789101 || 'Без номера',
        title: item.title || 'Без названия',
        status: 'completed',
        files: mainFiles,
        productionFiles: prodFiles,
        createdDate,
        completedDate: updatedDate,
        storageFiles: storageFiles,
        ufCrm3_1753795707997: storageFiles
      };
    });
  } catch (error) {
    console.error('Ошибка при получении готовых заказов:', error);
    throw error;
  }
}


  static async getActiveOrderssclad() {
    try {

      const token = localStorage.getItem('token');
    const config = {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    };

      let allItems = [];
      let start = 0;
      const limit = 50;
      let hasMore = true;

      while (hasMore) {
        const response = await axios.get(`${BITRIX_API_URL}crm.item.list`, {
          params: {
            'entityTypeId': '1036',
            'filter[stageId]': 'DT1036_8:NEW',
            'select[]': [
              'id',
              'title',
              'ufCrm3_1746789101',     // Номер заказа
              'ufCrm3_1746789910',    // Деталировка чертежа
              'ufCrm3_1746789890',    // Дизайн чертежа
              'ufCrm3_1753795707997'  // Файлы фурнитуры
            ],
            'start': start
          }
        });

        const items = response.data.result.items || [];
        allItems = allItems.concat(items);

        hasMore = items.length === limit;
        start += limit;

        if (items.length > 0) {
          console.log(`✅ Загружено ${items.length} заказов склада (итого: ${allItems.length})`);
        }

        if (start > 1000) {
          console.warn('⚠️ Достигнут лимит в 1000 заказов, прерываем загрузку');
          break;
        }
      }

      console.log(`🎯 Итого загружено заказов склада: ${allItems.length}`);

      return allItems.map(item => {
        const mainFiles = this.formatFiles(item.ufCrm3_1746789890);
        const prodFiles = this.formatFiles(item.ufCrm3_1746789910);
        const storageFiles = this.formatFiles(item.ufCrm3_1753795707997); // Обрабатываем файлы фурнитуры
        console.log(`API getActiveOrderssclad - Order ${item.id} raw furniture files:`, item.ufCrm3_1753795707997);
        console.log(`API getActiveOrderssclad - Order ${item.id} formatted furniture files:`, storageFiles);

        return {
          id: item.id,
          orderNumber: item.ufCrm3_1746789101 || 'Без номера',
          title: item.title || 'Без названия',
          status: 'new',
          files: mainFiles,
          productionFiles: prodFiles,
          storageFiles: storageFiles, // Файлы фурнитуры в стандартном поле
          ufCrm3_1753795707997: item.ufCrm3_1753795707997 // Исходные данные для отладки
        };
      });
    } catch (error) {
      console.error('Ошибка при получении заказов:', error);
      throw error;
    }
  }

  static async getActiveOrderszakup() {
    try {

      const token = localStorage.getItem('token');
    const config = {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    };

      let allItems = [];
      let start = 0;
      const limit = 50;
      let hasMore = true;

      while (hasMore) {
        const response = await axios.get(`${BITRIX_API_URL}crm.item.list`, {
          params: {
            'entityTypeId': '1036',
            'filter[stageId]': 'DT1036_8:PREPARATION',
            'select[]': [
              'id',
              'title',
              'ufCrm3_1746789101',
              'ufCrm3_1746789910',    // Деталировка чертежа
              'ufCrm3_1746789890',    // Дизайн чертежа
              'ufCrm3_1752145811415', // Файлы склада (base64)
              'ufCrm3_1753795707997'  // Файлы фурнитуры
            ],
            'start': start
          }
        });

        const items = response.data.result.items || [];
        allItems = allItems.concat(items);

        hasMore = items.length === limit;
        start += limit;

        if (items.length > 0) {
          console.log(`✅ Загружено ${items.length} заказов закупки (итого: ${allItems.length})`);
        }

        if (start > 1000) {
          console.warn('⚠️ Достигнут лимит в 1000 заказов, прерываем загрузку');
          break;
        }
      }

      console.log(`🎯 Итого загружено заказов закупки: ${allItems.length}`);

      return allItems.map(item => {
        const mainFiles = this.formatFiles(item.ufCrm3_1746789890);
        const prodFiles = this.formatFiles(item.ufCrm3_1746789910);
        // Пробуем оба поля для файлов склада
        const storageFiles1 = this.formatFiles(item.ufCrm3_1752145811415);
        const storageFiles2 = this.formatFiles(item.ufCrm3_1753795707997);
        const storageFiles = storageFiles1.length > 0 ? storageFiles1 : storageFiles2;
        console.log(`API getCompletedOrders - Order ${item.id} furniture files field:`, item.ufCrm3_1753795707997);
        console.log(`API getCompletedOrders - Order ${item.id} final storage files:`, storageFiles);

        return {
          id: item.id,
          orderNumber: item.ufCrm3_1746789101 || 'Без номера',
          title: item.title || 'Без названия',
          status: 'new',
          files: mainFiles,
          productionFiles: prodFiles,
          storageFiles: storageFiles,
          ufCrm3_1753795707997: storageFiles
        };
      });
    } catch (error) {
      console.error('Ошибка при получении заказов:', error);
      throw error;
    }
  }


  static async getActiveOrdersloft() {
    try {

      const token = localStorage.getItem('token');
    const config = {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    };

      let allItems = [];
      let start = 0;
      const limit = 50;
      let hasMore = true;

      while (hasMore) {
        const response = await axios.get(`${BITRIX_API_URL}crm.item.list`, {
          params: {
            'entityTypeId': '1036',
            'filter[stageId]': 'DT1036_6:UC_WE1KJE',
            'select[]': [
              'id',
              'title',
              'ufCrm3_1746789101',
              'ufCrm3_1746789910',    // Деталировка чертежа
              'ufCrm3_1746789890',    // Дизайн чертежа
              'ufCrm3_1754046893462'  // Загруженные фото лофта
            ],
            'start': start
          }
        });

        const items = response.data.result.items || [];
        allItems = allItems.concat(items);

        hasMore = items.length === limit;
        start += limit;

        if (items.length > 0) {
          console.log(`✅ Загружено ${items.length} заказов лофт (итого: ${allItems.length})`);
        }

        if (start > 1000) {
          console.warn('⚠️ Достигнут лимит в 1000 заказов, прерываем загрузку');
          break;
        }
      }

      console.log(`🎯 Итого загружено заказов лофт: ${allItems.length}`);

      return allItems.map(item => {
        const mainFiles = this.formatFiles(item.ufCrm3_1746789890);
        const prodFiles = this.formatFiles(item.ufCrm3_1746789910);
        const loftFiles = this.formatFiles(item.ufCrm3_1754046893462);

        return {
          id: item.id,
          orderNumber: item.ufCrm3_1746789101 || 'Без номера',
          title: item.title || 'Без названия',
          status: 'new',
          files: mainFiles,
          productionFiles: prodFiles,
          loftFiles: loftFiles
        };
      });
    } catch (error) {
      console.error('Ошибка при получении заказов:', error);
      throw error;
    }
  }


  
  static async searchOrdersInProduction(searchQuery) {
    try {
      const token = localStorage.getItem('token');
      const config = {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      };
  
      console.log(`Начинаем поиск заказов по запросу: "${searchQuery}"`);
      
      // Получаем список всех стадий из всех воронок (13, 29 и 49)
      const pipelineResponse = await axios.get(`${BITRIX_API_URL}crm.status.list`, {
        params: {
          'filter[ENTITY_ID]': ['DYNAMIC_147_STAGE_13', 'DYNAMIC_147_STAGE_29', 'DYNAMIC_147_STAGE_49']
        }
      });
      
      // Собираем стадии из всех воронок
      const allStages = [];
      
      // Воронка 13 - производство
      const stage13 = pipelineResponse.data.result
        .filter(stage => stage.ENTITY_ID === 'DYNAMIC_147_STAGE_13')
        .map(stage => stage.STATUS_ID);
      console.log(`Воронка 13: найдено ${stage13.length} стадий`);
      allStages.push(...stage13);
      
      // Воронка 29 - склад/закупка
      const stage29 = pipelineResponse.data.result
        .filter(stage => stage.ENTITY_ID === 'DYNAMIC_147_STAGE_29')
        .map(stage => stage.STATUS_ID);
      console.log(`Воронка 29: найдено ${stage29.length} стадий`);
      allStages.push(...stage29);
      
      // Воронка 49 - дополнительные стадии
      const stage49 = pipelineResponse.data.result
        .filter(stage => stage.ENTITY_ID === 'DYNAMIC_147_STAGE_49')
        .map(stage => stage.STATUS_ID);
      console.log(`Воронка 49: найдено ${stage49.length} стадий`);
      allStages.push(...stage49);
      
      console.log(`Всего стадий для поиска: ${allStages.length}`);
      
      const searchResults = [];
      
      // Для каждой стадии выполняем поиск
      for (const stageId of allStages) {
        try {
          const response = await axios.get(`${BITRIX_API_URL}crm.item.list`, {
            params: {
              'entityTypeId': '1036',
              'filter[stageId]': stageId,
              'filter[%ufCrm3_1746789101]': searchQuery, // Поиск по номеру заказа
              'select[]': [
                'id',
                'title',
                'ufCrm3_1746789101',
                'ufCrm7_1725965080328',    // Основные чертежи
                'ufCrm_1665746232568',     // Чертежи для производства
                'stageId'
              ]
            }
          });
          
          if (response.data.result?.items && response.data.result.items.length > 0) {
            const items = response.data.result.items;
            console.log(`Найдено ${items.length} заказов в стадии ${stageId}`);
            
            for (const item of items) {
              const mainFiles = this.formatFiles(item.ufCrm7_1725965080328);
              const prodFiles = this.formatFiles(item.ufCrm_1665746232568);
              
              searchResults.push({
                id: item.id,
                orderNumber: item.ufCrm3_1746789101 || 'Без номера',
                title: item.title || 'Без названия',
                stageId: item.stageId,
                files: mainFiles,
                productionFiles: prodFiles
              });
            }
          }
        } catch (stageError) {
          console.error(`Ошибка при поиске в стадии ${stageId}:`, stageError.message);
          // Продолжаем поиск в других стадиях
        }
      }
      
      console.log(`Всего найдено ${searchResults.length} заказов`);
      return searchResults;
    } catch (error) {
      console.error('Общая ошибка при поиске заказов:', error);
      throw error;
    }
  }



  static async getActiveOrdersupak() {
    try {
      const token = localStorage.getItem('token');
      const config = {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      };

      let allItems = [];
      let start = 0;
      const limit = 50;
      let hasMore = true;

      while (hasMore) {
        const response = await axios.get(`${BITRIX_API_URL}crm.item.list`, {
          params: {
            'entityTypeId': '1036',
            'filter[stageId]': 'DT1036_6:UC_SNLWF9',
            'select[]': [
              'id',
              'title',
              'ufCrm3_1746789101',
              'ufCrm3_1746789910',    // Деталировка чертежа
              'ufCrm3_1746789890',    // Дизайн чертежа
              'ufCrm3_1753076476775'  // Адрес заказа
            ],
            'start': start
          }
        });

        const items = response.data.result.items || [];
        allItems = allItems.concat(items);

        hasMore = items.length === limit;
        start += limit;

        if (items.length > 0) {
          console.log(`✅ Загружено ${items.length} заказов упаковки (итого: ${allItems.length})`);
        }

        if (start > 1000) {
          console.warn('⚠️ Достигнут лимит в 1000 заказов, прерываем загрузку');
          break;
        }
      }

      console.log(`🎯 Итого загружено заказов упаковки: ${allItems.length}`);

      return allItems.map(item => {
        const mainFiles = this.formatFiles(item.ufCrm3_1746789890);
        const prodFiles = this.formatFiles(item.ufCrm3_1746789910);

        return {
          id: item.id,
          orderNumber: item.ufCrm3_1746789101 || 'Без номера',
          title: item.title || 'Без названия',
          address: item.ufCrm3_1753076476775 || '',
          status: 'new',
          files: mainFiles,
          productionFiles: prodFiles
        };
      });
    } catch (error) {
      console.error('Ошибка при получении заказов:', error);
      throw error;
    }
  }

  static async getActiveOrdersSend() {
    try {
      const token = localStorage.getItem('token');
      const config = {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      };

      let allItems = [];
      let start = 0;
      const limit = 50;
      let hasMore = true;

      while (hasMore) {
        const response = await axios.get(`${BITRIX_API_URL}crm.item.list`, {
          params: {
            'entityTypeId': '1036',
            'filter[stageId]': 'DT1036_7:UC_ENW2F2',
            'select[]': [
              'id',
              'title',
              'ufCrm3_1746789101',    // Номер заказа
              'ufCrm3_1746789910',    // Деталировка чертежа
              'ufCrm3_1746789890'     // Дизайн чертежа
            ],
            'start': start
          }
        });

        const items = response.data.result.items || [];
        allItems = allItems.concat(items);

        hasMore = items.length === limit;
        start += limit;

        if (items.length > 0) {
          console.log(`✅ Загружено ${items.length} заказов для отправки (итого: ${allItems.length})`);
        }

        if (start > 1000) {
          console.warn('⚠️ Достигнут лимит в 1000 заказов, прерываем загрузку');
          break;
        }
      }

      console.log(`🎯 Итого загружено заказов для отправки: ${allItems.length}`);

      return allItems.map(item => {
        const mainFiles = this.formatFiles(item.ufCrm3_1746789890);
        const prodFiles = this.formatFiles(item.ufCrm3_1746789910);

        return {
          id: item.id,
          orderNumber: item.ufCrm3_1746789101 || 'Без номера',
          title: item.title || 'Без названия',
          status: 'send',
          files: mainFiles,
          productionFiles: prodFiles
        };
      });
    } catch (error) {
      console.error('Ошибка при получении заказов для отправки:', error);
      throw error;
    }
  }




  static async updateStagesclad(orderId) {
    try {
      const token = localStorage.getItem('token');
      
      const response = await axios.post(`${API_URL}/api/updateStagesclad`, 
        {
          itemId: orderId
        },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );

      return response.data;
    } catch (error) {
      console.error('Ошибка при обновлении стадии:', error);
      throw error;
    }
  }

static async updateStageloft(orderId) {
  try {
    const token = localStorage.getItem('token');
    
    const response = await axios.post(`${API_URL}/api/updateStageloft`, 
      {
        itemId: orderId
      },
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error('Ошибка при обновлении стадии:', error);
    throw error;
  }
}

// Методы для рабочего места
static async getActiveOrdersworkplace(stageId = 'DT1036_14:NEW') {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    };

    let allItems = [];
    let start = 0;
    const limit = 50;
    let hasMore = true;

    while (hasMore) {
      const response = await axios.get(`${BITRIX_API_URL}crm.item.list`, {
        params: {
          'entityTypeId': '1036',
          'filter[stageId]': stageId,
          'select[]': [
            'id',
            'title',
            'ufCrm3_1746789101',    // Order number
            'ufCrm3_1746789910',    // Technical drawings
            'ufCrm3_1746789890'     // Design drawings
          ],
          'start': start
        }
      });

      const items = response.data.result.items || [];
      allItems = allItems.concat(items);

      hasMore = items.length === limit;
      start += limit;

      if (items.length > 0) {
        console.log(`✅ Загружено ${items.length} заказов рабочего места (итого: ${allItems.length})`);
      }

      if (start > 1000) {
        console.warn('⚠️ Достигнут лимит в 1000 заказов, прерываем загрузку');
        break;
      }
    }

    console.log(`🎯 Итого загружено заказов рабочего места: ${allItems.length}`);

    return allItems.map(item => {
      const mainFiles = this.formatFiles(item.ufCrm3_1746789890);
      const prodFiles = this.formatFiles(item.ufCrm3_1746789910);

      return {
        id: item.id,
        orderNumber: item.ufCrm3_1746789101 || 'Без номера',
        title: item.title || 'Без названия',
        status: 'new',
        files: mainFiles,
        productionFiles: prodFiles
      };
    });
  } catch (error) {
    console.error('Ошибка при получении заказов рабочего места:', error);
    throw error;
  }
}

static async updateStageworkplace(orderId, targetStage) {
  try {
    const token = localStorage.getItem('token');
    
    const response = await axios.post(`${API_URL}/api/updateStageworkplace`, 
      {
        itemId: orderId,
        targetStage: targetStage
      },
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error('Ошибка при обновлении стадии рабочего места:', error);
    throw error;
  }
}

// Обновленный метод получения данных о товаре с его свойствами
static async getProductWithOptions(productId) {
  try {
    // Получаем сам товар
    const product = await this.getProduct(productId);
    
    // Получаем все доступные свойства для данного товара
    const availableOptions = {
      glassColors: [
        { id: 'transparent_8mm', name: 'Прозрачный (8 мм)' },
        { id: 'bronze_8mm', name: 'Бронза (8 мм)' },
        { id: 'graphite_8mm', name: 'Графит (8 мм)' }
      ],
      processingTypes: [
        { id: 'matte', name: 'Матовая обработка' },
        { id: 'combi_matte', name: 'Комби-матовая обработка' }
      ],
      fittingColors: [
        { id: 'chrome', name: 'Хром' },
        { id: 'black', name: 'Черный' },
        { id: 'bronze', name: 'Бронза' },
        { id: 'gold', name: 'Золото' },
        { id: 'graphite', name: 'Графит' }
      ],
      handleTypes: [
        { id: 'holder_275mm', name: 'Скоба (275 мм)' }
      ],
      additionalOptions: [
        { id: 'square_towel_holder', name: 'Полотенцедержатель квадратный (450x200 мм)' },
        { id: 'round_towel_holder', name: 'Полотенцедержатель круглый (450x200 мм)' }
      ],
      barTypes: [
        { id: 'standard', name: 'Стандартный' },
        { id: 'extended', name: 'Удлиненный' }
      ]
    };
    
    return {
      product,
      availableOptions
    };
  } catch (error) {
    console.error(`Ошибка при получении товара #${productId}:`, error);
    throw error;
  }
}



static async updateStageupak(orderId) {
  try {
    const token = localStorage.getItem('token');
    
    const response = await axios.post(`${API_URL}/api/updateStageupak`, 
      {
        itemId: orderId
      },
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error('Ошибка при обновлении стадии:', error);
    throw error;
  }
}

// Методы для самовывоза
static async getActiveOrderspickup() {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    };

    let allItems = [];
    let start = 0;
    const limit = 50;
    let hasMore = true;

    while (hasMore) {
      const response = await axios.get(`${BITRIX_API_URL}crm.item.list`, {
        params: {
          'entityTypeId': '1036',
          'filter[stageId]': 'DT1036_7:CLIENT',
          'select[]': [
            'id',
            'title',
            'ufCrm3_1746789101',
            'ufCrm3_1746789910',    // Деталировка чертежа
            'ufCrm3_1746789890'     // Дизайн чертежа
          ],
          'start': start
        }
      });

      const items = response.data.result.items || [];
      allItems = allItems.concat(items);

      hasMore = items.length === limit;
      start += limit;

      if (items.length > 0) {
        console.log(`✅ Загружено ${items.length} заказов на самовывоз (итого: ${allItems.length})`);
      }

      if (start > 1000) {
        console.warn('⚠️ Достигнут лимит в 1000 заказов, прерываем загрузку');
        break;
      }
    }

    console.log(`🎯 Итого загружено заказов на самовывоз: ${allItems.length}`);

    return allItems.map(item => {
      const mainFiles = this.formatFiles(item.ufCrm3_1746789890);
      const prodFiles = this.formatFiles(item.ufCrm3_1746789910);

      return {
        id: item.id,
        orderNumber: item.ufCrm3_1746789101 || 'Без номера',
        title: item.title || 'Без названия',
        status: 'pickup',
        files: mainFiles,
        productionFiles: prodFiles
      };
    });
  } catch (error) {
    console.error('Ошибка при получении заказов на самовывоз:', error);
    throw error;
  }
}

static async updateStagepickup(orderId) {
  try {
    const token = localStorage.getItem('token');
    
    const response = await axios.post(`${API_URL}/api/updateStagepickup`, 
      {
        itemId: orderId
      },
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error('Ошибка при обновлении стадии самовывоза:', error);
    throw error;
  }
}

static async updateStageToPurchase(orderId) {
  try {
    const token = localStorage.getItem('token');
    
    const response = await axios.post(`${API_URL}/api/updateStageToPurchase`, 
      {
        itemId: orderId
      },
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error('Ошибка при переводе заказа в закупку:', error);
    throw error;
  }
}

static async updateStageSend(orderId) {
  try {
    const token = localStorage.getItem('token');
    
    const response = await axios.post(`${API_URL}/api/updateStageSend`, 
      {
        itemId: orderId
      },
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error('Ошибка при обновлении стадии отправки:', error);
    throw error;
  }
}

  static async updateStagecutting(orderId) {
    try {
      const token = localStorage.getItem('token');
      
      const response = await axios.post(`${API_URL}/api/updateStage`, 
        {
          itemId: orderId
        },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );
  
      return response.data;
    } catch (error) {
      console.error('Ошибка при обновлении стадии:', error);
      throw error;
    }
  }

  static async updateStagedrilling(orderId) {
  try {
    const token = localStorage.getItem('token');
    
    const response = await axios.post(`${API_URL}/api/updateStagedrilling`, 
      {
        itemId: orderId
      },
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error('Ошибка при обновлении стадии:', error);
    throw error;
  }
} 

  // Получение всех проблемных заказов со всех стадий
  static async getAllProblemOrders() {
    try {
      const token = localStorage.getItem('token');

      const response = await axios.get(`${API_URL}/api/all-problem-orders`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.data.success) {
        return response.data;
      } else {
        throw new Error(response.data.message || 'Ошибка получения всех проблемных заказов');
      }
    } catch (error) {
      console.error('Ошибка при получении всех проблемных заказов:', error);
      throw error;
    }
  }

  // Получение проблемных заказов для резки (с неотмеченными деталями)
  static async getProblemOrdersCutting() {
    return this.getProblemOrders('rezka');
  }

  // Получение проблемных заказов для сверления (с неотмеченными деталями)
  static async getProblemOrdersDrilling() {
    return this.getProblemOrders('drilling');
  }

  // Получение проблемных заказов для закалки (с неотмеченными деталями)
  static async getProblemOrdersZakalka() {
    return this.getProblemOrders('zakalka');
  }

  // Получение проблемных заказов для матовки (с неотмеченными деталями)
  static async getProblemOrdersMatovka() {
    return this.getProblemOrders('matovka');
  }

  // Универсальный метод для получения проблемных заказов
  static async getProblemOrders(stage) {
    try {
      const token = localStorage.getItem('token');

      // Используем специальный endpoint для проблемных заказов
      const response = await axios.get(`${API_URL}/api/problem-orders`, {
        params: {
          stage: stage
        },
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.data.success) {
        return response.data.orders || [];
      } else {
        throw new Error(response.data.message || 'Ошибка получения проблемных заказов');
      }
    } catch (error) {
      console.error('Ошибка при получении проблемных заказов:', error);
      throw error;
    }
  }

  // Получение таймлайна заказа для анализа времени на стадиях
  static async getOrderTimeline(orderId) {
    try {
      console.log('Запрашиваем таймлайн для заказа:', orderId);
      const token = localStorage.getItem('token');
      
      const response = await axios.get(`${API_URL}/api/order-timeline/${orderId}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      console.log('Ответ сервера по таймлайну:', response.data);
      
      // Сервер возвращает объект { success: true, timeline: [...] }
      if (response.data.success) {
        return response.data.timeline || [];
      } else {
        console.warn('Сервер вернул неуспешный ответ:', response.data);
        return [];
      }
    } catch (error) {
      console.error('Ошибка при получении таймлайна заказа:', error);
      throw error;
    }
  }

  // Метод для получения расширенной информации о заказе
  static async getOrderDetails(orderId) {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_URL}/api/order-details/${orderId}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      console.log('Получена расширенная информация для заказа:', orderId);
      
      if (response.data.success) {
        return response.data.order;
      }
      return null;
    } catch (error) {
      console.error('Ошибка при получении расширенной информации о заказе:', error);
      throw error;
    }
  }

  // Получение всех заказов с полной информацией о времени и стадиях
  static async getAllOrdersWithTimeline() {
    try {
      const allOrdersPromises = [
        this.getActiveOrderscutting(),
        this.getActiveOrdersdrilling(),
        this.getActiveOrderszakalka(),
        this.getActiveOrdersmatovka(),
        this.getActiveOrdersloft(),
        this.getActiveOrdersupak(),
        this.getActiveOrderssclad(),
        this.getActiveOrderszakup(),
        this.getActiveOrdersSend(),
        this.getActiveOrderspickup(),
        this.getNazakOrders(),
        this.getCompletedOrders()
      ];

      const stages = [
        'cutting', 'drilling', 'zakalka', 'matovka', 
        'loft', 'upak', 'sclad', 'zakup', 
        'send', 'pickup', 'nazak', 'completed'
      ];

      const results = await Promise.all(allOrdersPromises);
      const allOrders = [];

      for (let i = 0; i < results.length; i++) {
        const stageOrders = results[i];
        const stageName = stages[i];
        
        for (const order of stageOrders) {
          // Получаем таймлайн для каждого заказа
          try {
            const timeline = await this.getOrderTimeline(order.id);
            
            allOrders.push({
              ...order,
              currentStage: stageName,
              stageName: this.getStageName(stageName),
              timeline: timeline,
              stageHistory: this.calculateStageHistory(timeline, stageName)
            });
          } catch (error) {
            console.warn(`Не удалось получить таймлайн для заказа ${order.id}:`, error);
            // Добавляем заказ без таймлайна
            allOrders.push({
              ...order,
              currentStage: stageName,
              stageName: this.getStageName(stageName),
              timeline: [],
              stageHistory: []
            });
          }
        }
      }

      return allOrders;
    } catch (error) {
      console.error('Ошибка при получении заказов с таймлайном:', error);
      throw error;
    }
  }

  // Анализ истории стадий на основе таймлайна
  static calculateStageHistory(timeline, currentStage) {
    if (!timeline || !Array.isArray(timeline)) {
      return [];
    }

    const stageMapping = {
      'DT1036_6:UC_58B1IG': 'cutting',
      'DT1036_6:UC_HD3BPN': 'drilling', 
      'DT1036_6:UC_TACW0R': 'zakalka',
      'DT1036_6:UC_4FXLEO': 'matovka',
      'DT1036_6:UC_WE1KJE': 'loft',
      'DT1036_6:UC_SNLWF9': 'upak',
      'DT1036_6:UC_PBEINX': 'nazak',
      'DT1036_8:NEW': 'sclad',
      'DT1036_8:PREPARATION': 'zakup',
      'DT1036_8:CLIENT': 'completed',
      'DT1036_7:UC_ENW2F2': 'send',
      'DT1036_7:CLIENT': 'pickup'
    };

    const stageHistory = [];
    let lastStageChange = null;

    // Сортируем таймлайн по времени создания
    const sortedTimeline = timeline.sort((a, b) => new Date(a.CREATED) - new Date(b.CREATED));

    sortedTimeline.forEach(item => {
      // Ищем изменения стадий в настройках или комментариях
      if (item.TYPE_ID === '2' && item.SETTINGS) { // Изменение в CRM
        try {
          const settings = JSON.parse(item.SETTINGS);
          if (settings.STAGE_ID) {
            const stage = stageMapping[settings.STAGE_ID];
            if (stage) {
              const stageTime = new Date(item.CREATED);
              
              if (lastStageChange) {
                // Вычисляем время пребывания на предыдущей стадии
                const timeInStage = Math.floor((stageTime - new Date(lastStageChange.time)) / (1000 * 60 * 60)); // часы
                lastStageChange.timeInStage = timeInStage;
                stageHistory.push(lastStageChange);
              }

              lastStageChange = {
                stage: stage,
                stageName: this.getStageName(stage),
                time: item.CREATED,
                timeInStage: null
              };
            }
          }
        } catch (error) {
          console.warn('Ошибка парсинга настроек таймлайна:', error);
        }
      }
    });

    // Добавляем текущую стадию
    if (lastStageChange) {
      const now = new Date();
      const timeInCurrentStage = Math.floor((now - new Date(lastStageChange.time)) / (1000 * 60 * 60));
      lastStageChange.timeInStage = timeInCurrentStage;
      stageHistory.push(lastStageChange);
    }

    return stageHistory;
  }

  // Получение имени стадии
  static getStageName(stage) {
    const stageMap = {
      cutting: 'Резка',
      drilling: 'Сверление', 
      zakalka: 'Закалка',
      matovka: 'Матовка',
      loft: 'Лофт',
      upak: 'Упаковка',
      sclad: 'Склад',
      zakup: 'Закупка',
      send: 'К отправке',
      pickup: 'Самовывоз', 
      nazak: 'Наряд',
      completed: 'Готов'
    };
    return stageMap[stage] || stage;
  }

  // Получение статистики по времени на стадиях
  static async getStageTimeAnalytics() {
    try {
      const orders = await this.getAllOrdersWithTimeline();
      const stageStats = {};

      orders.forEach(order => {
        if (order.stageHistory && order.stageHistory.length > 0) {
          order.stageHistory.forEach(stageInfo => {
            if (!stageStats[stageInfo.stage]) {
              stageStats[stageInfo.stage] = {
                stageName: stageInfo.stageName,
                totalTime: 0,
                orderCount: 0,
                orders: []
              };
            }

            if (stageInfo.timeInStage !== null) {
              stageStats[stageInfo.stage].totalTime += stageInfo.timeInStage;
              stageStats[stageInfo.stage].orderCount++;
              stageStats[stageInfo.stage].orders.push({
                orderNumber: order.orderNumber,
                orderId: order.id,
                timeInStage: stageInfo.timeInStage
              });
            }
          });
        }
      });

      // Вычисляем среднее время для каждой стадии
      Object.keys(stageStats).forEach(stage => {
        const stats = stageStats[stage];
        stats.averageTime = stats.orderCount > 0 ? Math.round(stats.totalTime / stats.orderCount) : 0;
        // Сортируем заказы по времени пребывания на стадии (по убыванию)
        stats.orders.sort((a, b) => b.timeInStage - a.timeInStage);
      });

      return stageStats;
    } catch (error) {
      console.error('Ошибка при получении аналитики стадий:', error);
      throw error;
    }
  }

  // ПРИМЕЧАНИЕ: Метод markDetailAsCompleted удален
  // Теперь все исправления выполняются только через модальное окно деталировки

  // ===== АРГОННАЯ СВАРКА =====

  static async getArgonOrders() {
    try {
      const token = localStorage.getItem('token');
      let allItems = [];
      let start = 0;
      const limit = 50;
      let hasMore = true;
      while (hasMore) {
        const response = await axios.get(`${BITRIX_API_URL}crm.item.list`, {
          params: {
            'entityTypeId': '1036',
            'filter[stageId]': 'DT1036_8:UC_CWW3XG',
            'select[]': ['id', 'title', 'ufCrm3_1746789101', 'ufCrm3_1746789910', 'ufCrm3_1746789890'],
            'start': start
          }
        });
        const items = response.data.result.items || [];
        allItems = allItems.concat(items);
        hasMore = items.length === limit;
        start += limit;
        if (start > 1000) break;
      }
      return allItems.map(item => ({
        id: item.id,
        orderNumber: item.ufCrm3_1746789101 || 'Без номера',
        title: item.title || 'Без названия',
        files: this.formatFiles(item.ufCrm3_1746789890),
        productionFiles: this.formatFiles(item.ufCrm3_1746789910)
      }));
    } catch (error) {
      console.error('Ошибка при получении заказов аргон:', error);
      throw error;
    }
  }

  static async getArgonInWorkOrders() {
    try {
      const token = localStorage.getItem('token');
      let allItems = [];
      let start = 0;
      const limit = 50;
      let hasMore = true;
      while (hasMore) {
        const response = await axios.get(`${BITRIX_API_URL}crm.item.list`, {
          params: {
            'entityTypeId': '1036',
            'filter[stageId]': 'DT1036_8:UC_H1Q1V5',
            'select[]': ['id', 'title', 'ufCrm3_1746789101', 'ufCrm3_1746789910', 'ufCrm3_1746789890'],
            'start': start
          }
        });
        const items = response.data.result.items || [];
        allItems = allItems.concat(items);
        hasMore = items.length === limit;
        start += limit;
        if (start > 1000) break;
      }
      return allItems.map(item => ({
        id: item.id,
        orderNumber: item.ufCrm3_1746789101 || 'Без номера',
        title: item.title || 'Без названия',
        files: this.formatFiles(item.ufCrm3_1746789890),
        productionFiles: this.formatFiles(item.ufCrm3_1746789910)
      }));
    } catch (error) {
      console.error('Ошибка при получении заказов аргон в работе:', error);
      throw error;
    }
  }

  static async getArgonDoneOrders() {
    try {
      const token = localStorage.getItem('token');
      let allItems = [];
      let start = 0;
      const limit = 50;
      let hasMore = true;
      while (hasMore) {
        const response = await axios.get(`${BITRIX_API_URL}crm.item.list`, {
          params: {
            'entityTypeId': '1036',
            'filter[stageId]': 'DT1036_8:UC_JGS4NP',
            'select[]': ['id', 'title', 'ufCrm3_1746789101', 'ufCrm3_1746789910', 'ufCrm3_1746789890'],
            'start': start
          }
        });
        const items = response.data.result.items || [];
        allItems = allItems.concat(items);
        hasMore = items.length === limit;
        start += limit;
        if (start > 1000) break;
      }
      return allItems.map(item => ({
        id: item.id,
        orderNumber: item.ufCrm3_1746789101 || 'Без номера',
        title: item.title || 'Без названия',
        files: this.formatFiles(item.ufCrm3_1746789890),
        productionFiles: this.formatFiles(item.ufCrm3_1746789910)
      }));
    } catch (error) {
      console.error('Ошибка при получении готовых заказов аргон:', error);
      throw error;
    }
  }

  static async updateStageToArgon(orderId) {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(`${API_URL}/api/updateStageToArgon`,
        { itemId: orderId },
        { headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' } }
      );
      return response.data;
    } catch (error) {
      console.error('Ошибка при переводе в аргон:', error);
      throw error;
    }
  }

  static async updateStageArgonInWork(orderId) {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(`${API_URL}/api/updateStageArgonInWork`,
        { itemId: orderId },
        { headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' } }
      );
      return response.data;
    } catch (error) {
      console.error('Ошибка при переводе в аргон в работе:', error);
      throw error;
    }
  }

  static async updateStageArgonDone(orderId) {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(`${API_URL}/api/updateStageArgonDone`,
        { itemId: orderId },
        { headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' } }
      );
      return response.data;
    } catch (error) {
      console.error('Ошибка при переводе аргон в готово:', error);
      throw error;
    }
  }

  // ===== БУХГАЛТЕРИЯ (entityTypeId: 1052, categoryId: 16) =====

  static BUH_ENTITY_TYPE_ID = 1052;
  static BUH_CATEGORY_ID = 16;

  static BUH_STAGES = {
    NEW: 'DT1052_16:UC_PDG1YA',
    APPROVED: 'DT1052_16:NEW',
    IN_PAYMENT: 'DT1052_16:UC_AGN0FL',
    PAID: 'DT1052_16:UC_5TPVIT',
    DONE: 'DT1052_16:SUCCESS',
    REJECTED: 'DT1052_16:FAIL',
  };

  static BUH_FIELDS = {
    EXPENSE_TYPE: 'ufCrm5_1772862090931',
    INVOICE_FILE: 'ufCrm5_1772862131909',
    POA_FILE: 'ufCrm5_1772862165903',
    SPEC_FILE: 'ufCrm5_1773060709245',
    PRIORITY: 'ufCrm5_1773061214683',
    COMMENT: 'ufCrm5_1773061261291',
    PAYMENT_ORDER_FILE: 'ufCrm5_1773061311135',
    WHO_RECEIVED: 'ufCrm5_1773061507339',
    COMPLETION_STATUS: 'ufCrm5_1773061569224',
    INITIATOR: 'ufCrm5_1773061670313',
    RELATED_ORDERS: 'ufCrm5_1773061831659',
    POA_STATUS: 'ufCrm5_1773290549587',
    REJECTION_REASON: 'ufCrm5_1773290634641',
    EDO_LINK: 'ufCrm5_1773290661626',
  };

  static formatBuhFiles(filesArray) {
    if (!filesArray || !Array.isArray(filesArray)) return [];
    return filesArray.map(file => {
      if (!file) return null;
      if (typeof file === 'object' && file.id) {
        return {
          id: file.id,
          name: file.name || `Файл ${file.id}`,
          url: file.urlMachine || file.url || null,
        };
      }
      return { id: file, name: `Файл ${file}`, url: null };
    }).filter(Boolean);
  }

  static mapBuhItem(item) {
    const F = BitrixAPI.BUH_FIELDS;
    return {
      id: item.id,
      title: item.title || '',
      stageId: item.stageId,
      opportunity: item.opportunity || 0,
      currencyId: item.currencyId || 'KZT',
      assignedById: item.assignedById,
      createdBy: item.createdBy,
      createdTime: item.createdTime,
      updatedTime: item.updatedTime,
      companyId: item.companyId,
      contactId: item.contactId,
      expenseType: item[F.EXPENSE_TYPE] || null,
      priority: item[F.PRIORITY] || null,
      comment: item[F.COMMENT] || '',
      initiator: item[F.INITIATOR] || '',
      relatedOrders: Array.isArray(item[F.RELATED_ORDERS])
        ? item[F.RELATED_ORDERS].join(', ')
        : (item[F.RELATED_ORDERS] || ''),
      rejectionReason: item[F.REJECTION_REASON] ? String(item[F.REJECTION_REASON]).trim() : '',
      edoLink: item[F.EDO_LINK] || '',
      whoReceived: item[F.WHO_RECEIVED] || '',
      completionStatus: item[F.COMPLETION_STATUS] || null,
      poaStatus: item[F.POA_STATUS] || null,
      invoiceFiles: BitrixAPI.formatBuhFiles(item[F.INVOICE_FILE]),
      poaFiles: BitrixAPI.formatBuhFiles(item[F.POA_FILE]),
      specFiles: BitrixAPI.formatBuhFiles(item[F.SPEC_FILE]),
      paymentOrderFiles: BitrixAPI.formatBuhFiles(item[F.PAYMENT_ORDER_FILE]),
    };
  }

  static async getBuhItems(stageIds = null) {
    try {
      const F = BitrixAPI.BUH_FIELDS;
      const selectFields = [
        'id', 'title', 'stageId', 'opportunity', 'currencyId',
        'assignedById', 'createdBy', 'createdTime', 'updatedTime',
        'companyId', 'contactId',
        F.EXPENSE_TYPE, F.INVOICE_FILE, F.POA_FILE, F.SPEC_FILE,
        F.PRIORITY, F.COMMENT, F.PAYMENT_ORDER_FILE, F.WHO_RECEIVED,
        F.COMPLETION_STATUS, F.INITIATOR, F.RELATED_ORDERS,
        F.POA_STATUS, F.REJECTION_REASON, F.EDO_LINK,
      ];

      let allItems = [];
      const stagesToFetch = stageIds || Object.values(BitrixAPI.BUH_STAGES);

      for (const stageId of stagesToFetch) {
        let start = 0;
        let hasMore = true;
        while (hasMore) {
          const params = {
            'entityTypeId': String(BitrixAPI.BUH_ENTITY_TYPE_ID),
            'filter[stageId]': stageId,
            'filter[categoryId]': String(BitrixAPI.BUH_CATEGORY_ID),
            'order[id]': 'DESC',
            'start': start,
          };
          selectFields.forEach((f, i) => { params[`select[${i}]`] = f; });

          const response = await axios.get(`${BITRIX_API_URL}crm.item.list`, { params });
          const items = response.data?.result?.items || [];
          allItems = allItems.concat(items.map(item => BitrixAPI.mapBuhItem(item)));
          hasMore = items.length === 50;
          start += 50;
          if (start > 500) break;
        }
      }

      // Для элементов с файлами без URL — запрашиваем полные данные через crm.item.get
      const itemsWithFiles = allItems.filter(item =>
        [...item.invoiceFiles, ...item.poaFiles, ...item.specFiles, ...item.paymentOrderFiles]
          .some(f => f.id && !f.url)
      );

      if (itemsWithFiles.length) {
        for (let i = 0; i < itemsWithFiles.length; i += 50) {
          const chunk = itemsWithFiles.slice(i, i + 50);
          const cmd = {};
          chunk.forEach(item => {
            cmd[`i${item.id}`] = `crm.item.get?entityTypeId=${BitrixAPI.BUH_ENTITY_TYPE_ID}&id=${item.id}`;
          });
          try {
            const resp = await axios.post(`${BITRIX_API_URL}batch`, { cmd });
            const results = resp.data?.result?.result || {};
            chunk.forEach(item => {
              const fullItem = results[`i${item.id}`]?.item;
              if (fullItem) {
                const enriched = BitrixAPI.mapBuhItem(fullItem);
                const idx = allItems.findIndex(a => a.id === item.id);
                if (idx !== -1) allItems[idx] = enriched;
              }
            });
          } catch (e) {
            console.error('Ошибка при получении файлов заявок:', e);
          }
        }
      }

      return allItems;
    } catch (error) {
      console.error('Ошибка при получении заявок бухгалтерии:', error);
      throw error;
    }
  }

  static async createBuhItem(fields) {
    try {
      const F = BitrixAPI.BUH_FIELDS;
      const itemFields = {
        title: fields.title,
        categoryId: BitrixAPI.BUH_CATEGORY_ID,
        stageId: BitrixAPI.BUH_STAGES.NEW,
        opportunity: fields.amount || 0,
        currencyId: 'KZT',
        [F.EXPENSE_TYPE]: fields.expenseType || null,
        [F.PRIORITY]: fields.priority || null,
        [F.COMMENT]: fields.comment || '',
        [F.INITIATOR]: fields.initiator || '',
        [F.RELATED_ORDERS]: fields.relatedOrders || '',
      };

      if (fields.invoiceFiles?.length) itemFields[F.INVOICE_FILE] = fields.invoiceFiles;
      if (fields.specFiles?.length)    itemFields[F.SPEC_FILE]    = fields.specFiles;

      const response = await axios.post(`${BITRIX_API_URL}crm.item.add`, {
        entityTypeId: BitrixAPI.BUH_ENTITY_TYPE_ID,
        fields: itemFields,
      });

      if (response.data?.result?.item) {
        return { success: true, item: BitrixAPI.mapBuhItem(response.data.result.item) };
      }
      throw new Error('Не удалось создать заявку');
    } catch (error) {
      console.error('Ошибка при создании заявки:', error);
      throw error;
    }
  }

  static async updateBuhItemStage(itemId, stageId, extraFields = {}) {
    try {
      const response = await axios.post(`${BITRIX_API_URL}crm.item.update`, {
        entityTypeId: BitrixAPI.BUH_ENTITY_TYPE_ID,
        id: itemId,
        fields: { stageId, ...extraFields },
      });

      if (response.data?.result) {
        return { success: true };
      }
      throw new Error('Не удалось обновить стадию');
    } catch (error) {
      console.error('Ошибка при обновлении стадии:', error);
      throw error;
    }
  }

  static async updateBuhItem(itemId, fields) {
    try {
      const response = await axios.post(`${BITRIX_API_URL}crm.item.update`, {
        entityTypeId: BitrixAPI.BUH_ENTITY_TYPE_ID,
        id: itemId,
        fields,
      });

      if (response.data?.result) {
        return { success: true };
      }
      throw new Error('Не удалось обновить заявку');
    } catch (error) {
      console.error('Ошибка при обновлении заявки:', error);
      throw error;
    }
  }

  static async getBuhItemById(itemId) {
    try {
      const response = await axios.get(`${BITRIX_API_URL}crm.item.get`, {
        params: {
          entityTypeId: String(BitrixAPI.BUH_ENTITY_TYPE_ID),
          id: String(itemId),
        },
      });
      const item = response.data?.result?.item;
      if (!item) throw new Error('Элемент не найден');
      return BitrixAPI.mapBuhItem(item);
    } catch (error) {
      console.error('Ошибка при получении заявки:', error);
      throw error;
    }
  }

}



export default BitrixAPI;
